import { ZipApiTimeoutError } from './ZipApiTimeoutError';

export class ZipApiError extends Error {
  constructor(public response: Response, message?: string) {
    super(message || `${response.status} ${response.statusText}`);
  }
}

export async function getApiErrorMessage(error: any, context: string): Promise<string> {
  if (error instanceof ZipApiTimeoutError) {
    return `${context}: the request timed out. Please try again.`;
  }
  if (error instanceof ZipApiError && error.response) {
    if (error.response.status === 504) {
      return `${context}: the request timed out. Please try again.`;
    }
    try {
      const body = await error.response.json();
      const detail = body.message || body.error;
      if (detail) return `${context}: ${detail}`;
    } catch {
      // response body wasn't JSON, use fallback
    }
  }
  return `${context}: an unexpected error occurred.`;
}
